import Vue from 'vue';
import VueRouter from 'vue-router';
import {routers} from './router';
import iView from 'view-design';
import Util from '../lib/util';
import Cookies from 'js-cookie';
import { appRouters, otherRouters } from './router';
// import style
// import 'view-design/dist/styles/iview.css';
Vue.use(VueRouter);

const RouterConfig = {
    routes: routers
};

export const router = new VueRouter(RouterConfig);

//解决重复点击菜单报错
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push(location:string) {
return (originalPush.call(this, location) as any).catch((err:any) => err)
}

router.beforeEach((to, from, next) => {
            console.log("🚀 ~ file: index.ts:39 ~ router.beforeEach ~ Util.abp.session", Util.abp.session)
    
    // iView.LoadingBar.start();
    //CHB修改
    // Util.title(to.meta.title);
    if (Cookies.get('locking') === '1' && to.name !== 'locking') {
        next({
            replace: true,
            name: 'locking'
        });
        
    } else if (to.name == 'sso' ||  to.name =='householdDocumentProcessingFormDetailPhone'|| to.name =='householdArchiveDetailPhone'|| to.name =='householdJZHEndSandOrderPhone'||to.name =='householdRCYJEndSandOrderPhone'||to.name =='householdLXSEndSandOrderPhone'||to.name =='householdJKEndSandOrderPhone'||to.name =='businessAssistant') {
        // 白名單
        next();
    }else if (Cookies.get('locking') === '0' && to.name === 'locking') {
        next(false);
    } else {
        if (!Util.abp.session.userId&& to.name !== 'login') {
            next({
                name: 'login'
            });
        } else if (!!Util.abp.session.userId && to.name === 'login') {
            Util.title(to.meta.title); 
            next({
                name: 'home'
            });
        } else {
            const curRouterObj = Util.getRouterObjByName([otherRouters, ...appRouters], to.name);
            if (curRouterObj && curRouterObj.permission) {
                if (window.abp.auth.hasPermission(curRouterObj.permission)) {
                    Util.toDefaultPage([otherRouters, ...appRouters], to.name, router, next);
                } else {
                    next({
                        replace: true,
                        name: 'error-403'
                    });
                }
            } else {
                Util.toDefaultPage([...routers], to.name, router, next);
            }
        }
    }
});
router.afterEach((to) => {
    Util.openNewPage(router.app, to.name, to.params, to.query);
    // iView.LoadingBar.finish();
    window.scrollTo(0, 0);
});